export default {
    data: () => ({
        isLoading: false,
        fullPage: true,
        color: '#00AB00',
        width: 256,
    }),
    methods: {
        onCancel() {
            console.log('User cancelled the loader.')
        }
    }
};
